module.exports = __webpack_public_path__ + "img/gontgshang.4e199250.png";